import { assoc, compose, dissoc, map, pick } from 'ramda'

import { formatApiDate } from '../../../../utils/helpers/date'
import { cleanFieldValuesRequestClone } from '../../../../utils/helpers/fields'

export const cleanRequest = item =>
  compose(
    pick([
      'userId',
      'checklistId',
      'placeId',
      'priorityId',
      'address',
      'description',
      'parentId',
      'documents',
      'groupId',
      'events',
      'fieldValues',
      'metadata'
    ]),

    assoc('events', [{ statusId: 1, eventDate: formatApiDate(new Date()) }]),
    assoc('userId', item.user?.id || null),
    assoc('groupId', item.group?.id || null),
    assoc('documents', map(pick(['id']), item.documents || [])),
    assoc('address', item.address ? dissoc('__typename', item.address) : undefined),
    assoc('fieldValues', cleanFieldValuesRequestClone(item.fieldValues || []))
  )(item)
